import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons"

export const ShoppingCart = (props) => {
  return <FontAwesomeIcon faIcon={faShoppingCart} {...props} />
}
